import api from './api';
import { LoginCredentials, LoginResponse, User, ApiResponse } from '../types';

export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  gender: string;
}

export interface PendingRegistration {
  id: number;
  email: string;
  createdAt: string;
  employee: { id: number; firstName: string; lastName: string; employeeCode: string };
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>('/auth/login', credentials);
    return response.data.data!;
  },

  async register(data: RegisterData): Promise<{ message: string }> {
    const response = await api.post<ApiResponse<{ message: string }>>('/auth/register', data);
    return response.data.data!;
  },

  async getProfile(): Promise<User> {
    const response = await api.get<ApiResponse<User>>('/auth/me');
    return response.data.data!;
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password', { currentPassword, newPassword });
  },

  async getNotifications(): Promise<{ pendingLeaveCount: number; pendingRegistrationCount: number }> {
    const response = await api.get<ApiResponse<{ pendingLeaveCount: number; pendingRegistrationCount: number }>>('/auth/notifications');
    return response.data.data ?? { pendingLeaveCount: 0, pendingRegistrationCount: 0 };
  },

  async getPendingRegistrations(): Promise<PendingRegistration[]> {
    const response = await api.get<ApiResponse<PendingRegistration[]>>('/auth/pending-registrations');
    return response.data.data || [];
  },

  async approveRegistration(userId: number): Promise<void> {
    await api.post(`/auth/pending-registrations/${userId}/approve`);
  },

  async rejectRegistration(userId: number): Promise<void> {
    await api.post(`/auth/pending-registrations/${userId}/reject`);
  },

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};
